<template>
  <div>
    <div class="w3-container">
      <div class="w3-hide-print">
        <div>
          <header>
            <h2>Dashboard - {{state.activeSite.domain}}</h2>
          </header>
        </div>
      </div>

      <div :class="state.siteData.site_l7s_analytics_id && state.siteData.site_l7s_analytics_id !== '' ? 'dashGrid' : ''">
        <div class="dashAnalyticsGrid" v-if="state.siteData.site_l7s_analytics_id && state.siteData.site_l7s_analytics_id !== ''">
          <div>
            <div class="inputCard mb-2">
              <header class="w3-left-align">Overall Visits</header>
              <div class="content w3-padding-top">
                <apexchart width="100%" type="bar" :options="overallVisitorChart.options" :series="overallVisitorChart.data"></apexchart>
              </div>
            </div>
          </div>
          <div>
            <div class="inputCard mb-2">
              <header class="w3-left-align">Unique Visits</header>
              <div class="content w3-padding-top">
                <apexchart width="100%" type="bar" :options="uniqueVisitorChart.options" :series="uniqueVisitorChart.data"></apexchart>
              </div>
            </div>
          </div>
          <div>
            <div class="inputCard mb-2">
              <header class="w3-left-align">Bounce Rate</header>
              <div class="content w3-padding-top">
                <apexchart width="100%" type="bar" :options="bounceRateChart.options" :series="bounceRateChart.data"></apexchart>
              </div>
            </div>
          </div>
        </div>
        <div class="quickActions" :class="state.siteData.site_l7s_analytics_id && state.siteData.site_l7s_analytics_id !== '' ? '' : 'quickActionsGrid'">
          <div class="mb-2">
            <b-list-group>
              <b-list-group-item class="text-white listHeader">Manage Page Content</b-list-group-item>
              <b-list-group-item class="pointer" @click="pageNav('cmsPagesHome')">Home Page</b-list-group-item>
              <b-list-group-item v-if="state.siteData.pages.services.enabled" class="pointer" @click="pageNav('cmsPagesServices')">Services Page</b-list-group-item>
              <b-list-group-item v-if="state.siteData.pages.news.enabled" class="pointer" @click="pageNav('cmsPagesNews')">News Page</b-list-group-item>
              <b-list-group-item v-if="state.siteData.pages.about.enabled" class="pointer" @click="pageNav('cmsPagesAbout')">About Page</b-list-group-item>
              <b-list-group-item v-if="state.siteData.pages.shop.enabled" class="pointer" @click="pageNav('cmsPagesShop')">Shop Page</b-list-group-item>
              <b-list-group-item v-if="state.siteData.pages.contact.enabled" class="pointer" @click="pageNav('cmsPagesContact')">Contact Page</b-list-group-item>
            </b-list-group>
          </div>
          <div class="mb-2" v-if="state.siteData.pages.shop.enabled">
            <b-list-group>
              <b-list-group-item class="text-white listHeader">Manage Shop</b-list-group-item>
              <b-list-group-item class="pointer" @click="pageNav('cmsProducts')">Products</b-list-group-item>
              <b-list-group-item class="pointer" @click="pageNav('cmsProductCategories')">Categories</b-list-group-item>
              <b-list-group-item class="pointer" @click="pageNav('cmsProductOrders')">Orders</b-list-group-item>
            </b-list-group>
          </div>
          <div class="mb-2" v-if="state.siteData.pages.news.enabled">
            <b-list-group>
              <b-list-group-item class="text-white listHeader">Manage News</b-list-group-item>
              <b-list-group-item class="pointer" @click="pageNav('cmsNewsDetail')">New Post</b-list-group-item>
              <b-list-group-item class="pointer" @click="pageNav('cmsNews')">View Posts</b-list-group-item>
            </b-list-group>
          </div>
          <div class="mb-2" v-if="state.siteData.content.properties.enabled">
            <div class="inputCard">
              <header class="w3-left-align">Manage Properties</header>
              <div class="content">
                <div class="cardRow w3-padding-8 pointer" @click="pageNav('cmsPropertiesDetail')">New Property</div>
                <div class="cardRow w3-padding-8 pointer" @click="pageNav('cmsProperties')">View Properties</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var dataStore = require('../../dataStore').default

export default {
  name: 'cmsdash',
  data() {
    return {
      state: dataStore.state,
      view: 'global',
      saving: false,
      saved: false,
      overallVisitorChart: {
        options: {
          chart: {
            id: 'overall-visitors-chart'
          },
          xaxis: {
            categories: []
          }
        },
        data: [{
          name: 'overall-visitors',
          data: []
        }]
      },
      uniqueVisitorChart: {
        options: {
          chart: {
            id: 'unique-visitors-chart'
          },
          xaxis: {
            categories: []
          }
        },
        data: [{
          name: 'unique-visitors',
          data: []
        }]
      },
      bounceRateChart: {
        options: {
          chart: {
            id: 'bounce-rate-chart'
          },
          xaxis: {
            categories: []
          }
        },
        data: [{
          name: 'bounce-rate',
          data: []
        }]
      }
    }
  },
  created() {
    if (this.state.siteData.site_l7s_analytics_id !== '') {
      dataStore.getAnalytics('getVisitors', this.state.siteData.site_l7s_analytics_id, 'day', 'last7').then((res) => {
        if (res === 'success') {
          let categories = []
          for (let point of Object.keys(this.state.siteAnalytics.visitors)) {
            categories.push(this.$options.filters.dateSelect(point, {month: 'short', day: 'numeric'}))
            // Overall Visits
            if (this.state.siteAnalytics.visitors[point].nb_visits) {
              this.overallVisitorChart.data[0].data.push(this.state.siteAnalytics.visitors[point].nb_visits)
            } else {
              this.overallVisitorChart.data[0].data.push(0)
            }
            // Unique Visitors
            if (this.state.siteAnalytics.visitors[point].nb_uniq_visitors) {
              this.uniqueVisitorChart.data[0].data.push(this.state.siteAnalytics.visitors[point].nb_uniq_visitors)
            } else {
              this.uniqueVisitorChart.data[0].data.push(0)
            }
            // Bounce Rate
            if (this.state.siteAnalytics.visitors[point].bounce_rate) {
              this.bounceRateChart.data[0].data.push(this.state.siteAnalytics.visitors[point].bounce_rate)
            } else {
              this.bounceRateChart.data[0].data.push(0)
            }
          }
          // console.log(categories)

          this.overallVisitorChart.options = {
            plotOptions: {
              bar: {
                dataLabels: {
                  position: 'bottom'
                }
              }
            },
            chart: {
              id: 'overall-visitors-chart'
            },
            xaxis: {
              categories: categories,
              labels: {
                style: {
                  colors: ['#666', '#666', '#666', '#666', '#666', '#666', '#666']
                }
              }
            }
          }
          this.uniqueVisitorChart.options = {
            plotOptions: {
              bar: {
                dataLabels: {
                  position: 'bottom'
                }
              }
            },
            chart: {
              id: 'unique-visitors-chart'
            },
            xaxis: {
              categories: categories,
              labels: {
                style: {
                  colors: ['#666', '#666', '#666', '#666', '#666', '#666', '#666']
                }
              }
            }
          }
          this.bounceRateChart.options = {
            plotOptions: {
              bar: {
                dataLabels: {
                  position: 'bottom'
                }
              }
            },
            chart: {
              id: 'bounce-rate-chart'
            },
            xaxis: {
              categories: categories,
              labels: {
                style: {
                  colors: ['#666', '#666', '#666', '#666', '#666', '#666', '#666']
                }
              }
            },
            yaxis: {
              labels: {
                formatter: (value) => {
                  return value + '%'
                }
              }
            }
          }
        }
      })
    }
  },
  methods: {
    saveContent() {
      this.saving = true
      dataStore.saveSiteData().then((res) => {
        this.saving = false
        if (res === 'success') {
          this.saved = true
          setTimeout(() => {
            this.saved = false
          }, 2000)
        }
      })
    },
    pageNav(page) {
      console.log(page)
      if (page === 'cmsPagesHome') {
        this.state.pageNav = 'home'
        this.$router.push('/cms/pages')
      }
      if (page === 'cmsPagesServices') {
        this.state.pageNav = 'services'
        this.$router.push('/cms/pages')
      }
      if (page === 'cmsPagesNews') {
        this.state.pageNav = 'news'
        this.$router.push('/cms/pages')
      }
      if (page === 'cmsPagesAbout') {
        this.state.pageNav = 'about'
        this.$router.push('/cms/pages')
      }
      if (page === 'cmsPagesShop') {
        this.state.pageNav = 'shop'
        this.$router.push('/cms/pages')
      }
      if (page === 'cmsPagesContact') {
        this.state.pageNav = 'contact'
        this.$router.push('/cms/pages')
      }
      if (page === 'cmsProducts') {
        this.state.pageNav = 'products'
        this.$router.push('/cms/products')
      }
      if (page === 'cmsProductCategories') {
        this.state.pageNav = 'productCategories'
        this.$router.push('/cms/product-categories')
      }
      if (page === 'cmsProductOrders') {
        this.state.pageNav = 'productOrders'
        this.$router.push('/cms/product-orders')
      }
      if (page === 'cmsNews') {
        this.state.pageNav = 'cmsNews'
        this.$router.push('/cms/news')
      }
      if (page === 'cmsNewsDetail') {
        this.state.pageNav = 'cmsNewsDetail'
        this.$router.push('/cms/news-detail')
      }
      if (page === 'cmsProperties') {
        this.state.pageNav = 'properties'
        this.$router.push('/cms/properties')
      }
      if (page === 'cmsPropertiesDetail') {
        this.state.pageNav = 'properties-detail'
        this.$router.push('/cms/properties-detail')
      }
    }
  }
}
</script>

<style scoped>
  .dashAnalyticsGrid {display: grid; grid-template-columns: 1fr 1fr; grid-gap: 8px;}
  .dashGrid {display: grid; grid-template-columns: 3fr 1fr; grid-gap: 8px;}
  .quickActionsGrid {display: grid; grid-template-columns: 1fr 1fr 1fr; grid-gap: 8px;}

  @media (max-width: 600px) {
    .dashGrid {grid-template-columns: 1fr;}
    .dashAnalyticsGrid, .quickActionsGrid {grid-template-columns: 1fr;}
  }
</style>



// WEBPACK FOOTER //
// src/components/cms/cmsDash.vue